import { render, staticRenderFns } from "./SelectGame.vue?vue&type=template&id=5cbde439&scoped=true"
import script from "./SelectGame.vue?vue&type=script&lang=js"
export * from "./SelectGame.vue?vue&type=script&lang=js"
import style0 from "./SelectGame.vue?vue&type=style&index=0&id=5cbde439&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbde439",
  null
  
)

export default component.exports